export const ASCENDING = 'ascending';
export const DESCENDING = 'descending';

export const all = [ASCENDING, DESCENDING];

export type SortDirection = 'ascending' | 'descending';
